// extracted by mini-css-extract-plugin
export var label = "_gq-0";
export var treatmentCard = "_gq-1";